import { Component, forwardRef, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { GlobalSearchItem, GlobalSearchPageType, Language, LanguageService } from 'itcores-fw';
import { AuthTypeEnum } from 'src/app/modules/auth/models/auth-type-enum';
import { User } from 'src/app/modules/auth/models/authModel';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { AppUrls } from '../../helpers/app-urls';
declare let $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HeaderComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => HeaderComponent),
      multi: true,
    },
  ]
})
export class HeaderComponent implements OnInit {

  /* #region  Fields */
  lang: Language;
  changedLang = false;
  currentUser: User;
  leftmenuToggler: any;
  userNotificationsCount: number;
  form: FormGroup;
  excludeModuleId = environment.excludeModuleId;

  /* #endregion */
  isColor = 'light';
  /* #region   Constructor*/
  constructor(
    private router: Router,
    private _authService: AuthService,
    private language: LanguageService,
    public translate: TranslateService,
    private fb: FormBuilder,
    private msalService: MsalService
  ) {
    this.form = fb.group({});
  }
  /* #endregion */

  /* #region  Properties */

  /* #endregion */

  /* #region  Events */
  ngOnInit() {
    this.isColor = localStorage.getItem("userThemeBackColor") || 'ligth';
    const authType = this._authService.getAuthType();
    if (authType === AuthTypeEnum.Custom) {
      this.currentUser = this._authService.currentUser;
    } else if (authType === AuthTypeEnum.OIDC) {
      // const account = this.msalService.getAccount();
      // if (account) {
      //   this.currentUser = {
      //     EmployeeId: account.sid,
      //     Name: account.name,
      //     UserName: account.userName
      //   };
      // }
    }

    // global search
    $('.search-toggle-btn').on('click', function () {
      $('.global-search').toggleClass('show-search-form');
    });
  }
  clickbar() {
    // collapse menu


    $('#sidebar').toggleClass('collapse');
    $('.content').toggleClass('expand');
    // $('.icon-toggle-side-menu i').toggleClass('toggle-icon');
    $('.body-overlay').toggle(500);

  }
  onSelectSearchKey(event: GlobalSearchItem) {
    Object.keys(AppUrls).forEach((key, index) => {
      if (
        AppUrls[key]['props'] !== null &&
        AppUrls[key]['props'] !== undefined &&
        AppUrls[key]['props']['name'] === event.name
      ) {
        if (event.uiComponentType === GlobalSearchPageType.list) {
          this.router.navigate([AppUrls[key]['list']]);
        } else if (event.uiComponentType === GlobalSearchPageType.details) {
          if (AppUrls[key]['details']) {
            this.router.navigate([AppUrls[key]['details'], event.id]);
          }
        }
      }
    });
  }

  /* #endregion */

  /* #region  Methods */
  changeLang() {
    if (this.language.Lang === Language.Arabic) {
      this.language.setLanguage(Language.English);
      document.body.dir = 'ltr';
    } else {
      this.language.setLanguage(Language.Arabic);
      document.body.dir = 'rtl';
    }
  }

  logout() {
    this._authService.logout();
  }

  preventClose(event) {
    event.stopPropagation();
  }

  /* #endregion */
  customerModeChanged(colorMode: string) {
    this.isColor = colorMode || 'dark';
    // this.isColor = 'true';
    $('body').attr('data-default-color', colorMode);
    localStorage.setItem('userThemeBackColor', colorMode);
  }
}
